import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import { IParticipant } from 'bets.oddprovider.lib.common.ts/models'
import axios from '../../apiClient/axios'
import { ParticipantsApiClient } from '../../apiClient/participants'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface IParticipantsAction extends IDefaultAction {
  payload?: IParticipant[],
}

export interface IParticipantsState extends IDefaultState {
  payload?: IParticipant[],
}

const initState: IParticipantsState = {}

export const participantsStateLoadFromApi = createAsyncThunk(
  'participantsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IParticipant>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<IParticipant>> = await new ParticipantsApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const participantsSlice = createSlice({
  name: 'participantsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(participantsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(participantsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(participantsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearParticipants } = participantsSlice.actions
export default participantsSlice.reducer 